import { gql } from '@apollo/client'

export const REMOVE_USERS_FROM_ZONE = gql`
  mutation RemoveUsersFromZone($input: UpdateZoneInput!) {
    removeUsersFromZone(input: $input) {
      success
    }
  }
`
